import { ICustomerFileLinkRes } from '../interfaces/customer.interface';

export class FileLinkDto implements ICustomerFileLinkRes {
  key!: string;

  url!: string;
}
